// Mensajes de notificación
export const NOTIFICATION_MESSAGES = {
  success: {
    create: {
      title: "Éxito",
      description: "La herramienta IA ha sido creada exitosamente.",
    },
    update: {
      title: "Éxito", 
      description: "La herramienta IA ha sido actualizada exitosamente.",
    },
  },
  error: {
    general: {
      title: "Error",
      description: "Ha ocurrido un error, por favor intente nuevamente.",
    },
    loading: {
      title: "Error",
      description: "La información no pudo ser cargada, por favor notifica éste error!",
    },
  },
};

// Labels del formulario
export const FORM_LABELS = {
  title: "Título",
  description: "Resumen de Herramienta", 
  prompt: "Prompt",
  cover: "Cover",
  exampleText: "Ejemplo de Texto",
  numberOfLines: "Número de líneas",
  contentElements: "Elementos de Contenido",
  contentItem: "Elemento de Contenido",
};

// Placeholders 
export const PLACEHOLDERS = {
  es: {
    title: "Ingrese el título",
    description: "Ingrese el resumen", 
    prompt: "Ingrese el prompt",
    contentTitle: "Título del contenido",
    exampleText: "Ejemplo de texto para este contenido",
    lines: "Líneas",
  },
  en: {
    title: "Enter title",
    description: "Enter summary",
    prompt: "Enter prompt", 
    contentTitle: "Content title",
    exampleText: "Example text for this content",
    lines: "Lines",
  },
};

// Botones
export const BUTTON_LABELS = {
  save: "Guardar",
  cancel: "Cancelar",
  testValidation: "Test Validación",
  addContent: "Añadir Elemento de Contenido",
  delete: "Eliminar",
};

// Títulos de página
export const PAGE_TITLES = {
  edit: "Editar Herramienta IA",
  create: "Nueva Herramienta IA",
};

// Configuración de idiomas
export const SUPPORTED_LANGUAGES = ["es", "en"] as const;

// Configuración de notificaciones
export const NOTIFICATION_CONFIG = {
  placement: "top" as const,
  duration: 3,
}; 